import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Presentational toast used across the app. Each host component still owns its
 * own show/hide state and auto-dismiss timing (that behavior differs per screen) —
 * this only replaces the markup/CSS that was previously hand-copied in each one.
 */
@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  @Input() visible = false;
  @Input() message = '';
  @Input() isError = false;
}
